import React from 'react'
import {useInjection} from 'dna-react-ioc'
import {observer} from 'mobx-react'
import {Table} from 'antd'
import {ITransactionsHistoryDataStore} from '@/pages/Overview'
import {PaginationContainer} from '@/components'
import {useScreenType} from '@/hooks'
import {LoadingState} from '@/types'
import {getColumns} from '@/pages/Settlements/PerSettlementDate/components/PerSettlementDateTransactionsHistoryTable/constants'

export const PerSettlementDateTransactionsHistoryDataStoreSymbol = Symbol(
    'PerSettlementDateTransactionsHistoryDataStore'
)
export const PerSettlementDateTransactionsHistoryPaginationStoreSymbol = Symbol(
    'PerSettlementDateTransactionsHistoryPaginationStore'
)

export const PerSettlementDateTransactionsHistoryTable = observer(() => {
    const {isMobile} = useScreenType()
    const {data, loadingState} = useInjection<ITransactionsHistoryDataStore>(
        PerSettlementDateTransactionsHistoryDataStoreSymbol
    )
    const columns = getColumns()

    return (
        <>
            {isMobile && (
                <PaginationContainer
                    showOnlySizeChanger={true}
                    injectableIdentifier={PerSettlementDateTransactionsHistoryPaginationStoreSymbol}
                />
            )}
            <Table
                loading={loadingState === LoadingState.LOADING}
                dataSource={data}
                columns={columns}
                pagination={false}
                scroll={{x: 'max-content'}}
            />
            <PaginationContainer
                hideSizeChanger={isMobile}
                injectableIdentifier={PerSettlementDateTransactionsHistoryPaginationStoreSymbol}
            />
        </>
    )
})
